import { BudgetTemplate } from "@project/domain/models/budget-template/budget-template";
import { inject, injectable } from "inversify";

@injectable()
export class BudgetTemplateMapper {
    map(dto: any): BudgetTemplate {
        return {
            id: dto.id,
            name: dto.name,
            description: dto.description,
            finantial_entity: dto.finantial_entity,
            created: dto.created,
            modified: dto.modified,
            is_template: dto.is_template,
        };
    }
}

@injectable()
export class BudgetTemplatesMapper {
    constructor(
        @inject(BudgetTemplateMapper)
        private readonly budgetTemplateMapper: BudgetTemplateMapper,
    ) { }

    map(dtos: any[]): BudgetTemplate[] {
        return dtos.map((dto) => this.budgetTemplateMapper.map(dto));
    }
}
